__webpack_require__.p = "/my/investment/funds/";